import { Action } from '@ngrx/store';

import { UserInfo } from '@digihaven/shared';

export enum UserActionTypes {
    Set = '[User] Set',
    Unset = '[User] Unset'
}

export class SetUser implements Action {
    type: UserActionTypes.Set = UserActionTypes.Set;
    constructor(public payload: UserInfo) {}
}

export class UnsetUser implements Action {
    type: UserActionTypes.Unset = UserActionTypes.Unset;
}

export type UserActions = SetUser | UnsetUser;
